import Splide from '@splidejs/splide';
import Util from "../libs/Util";

export default class MvGallery {
  constructor() {

    this.target = document.querySelector('.page_hotel_detail .mv .splide');

    this.splide = null;

    this.splide = new Splide(this.target,{
      rewind: false,
      breakpoints: {
        [Util.BREAK_POINT]: {
          rewind: true,
        }
      },
      pagination: false,
      arrows: true,
      flickPower: 100,
    });

    this.updateArrowButtons = () => {
      const prev = this.target.querySelector('.splide__arrow--prev');
      const next = this.target.querySelector('.splide__arrow--next');
      const isSp = window.innerWidth <= Util.BREAK_POINT;

      if (isSp) {
        prev.style.display = '';
        next.style.display = '';
        return;
      }

      const track = this.target.querySelector('.splide__track');
      const firstSlide = this.target.querySelector('.splide__slide');
      
      if (!track || !firstSlide) return;

      const slideWidth = firstSlide.offsetWidth;
      const trackWidth = track.offsetWidth;
      const visibleCount = Math.floor(trackWidth / slideWidth);
      const lastIndex = Math.max(0, this.splide.length - visibleCount);

      // dragで末尾まで移動した場合、表示中の最後のページに補正する
      if (this.splide.index > lastIndex) {
        this.splide.go(lastIndex, true);
        return;
      }
      
      prev.style.display = (this.splide.index === 0) ? 'none' : '';
      next.style.display = (this.splide.index >= lastIndex) ? 'none' : '';
    };

    this.splide.on('mounted', () => {
      // mountedイベント後に直接updateArrowButtonsを呼ぶ
      this.updateArrowButtons();
    });

    this.splide.on('moved', () => {
      this.updateArrowButtons();
    });
    this.splide.mount();
  }
}
